export interface Capacity {
  id?: string;
  adults: number;
  children: number;
  infants: number;
  teenagers: number;
}

export const DEFAULT_CAPACITY: Capacity = {
  adults: 0,
  children: 0,
  infants: 0,
  teenagers: 0,
};
